import { apiClient } from "./ApiClient";

export const getTodayRatesApi    = () => apiClient.get("/api/data/today-rates");
export const getAllFxRatesApi    = () => apiClient.get("/fx-rate-view/rates");
export const recordTodayRatesApi = () => apiClient.post("/fx-rate-view/record-today");

/**
 * Fetches the FX rate for a specific date.
 * The backend checks the local DB first; only calls the external exchange-rate
 * API when the date is not yet stored.  The external API key never leaves the
 * server — this call only reaches our own authenticated backend.
 *
 * @param {string} date  ISO date string: YYYY-MM-DD
 */
export const getRateForDateApi = (date) =>
  apiClient.get(`/fx-rate-view/rate-for-date?date=${encodeURIComponent(date)}`);
